import { useState, useEffect } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

const BUYER_INCENTIVES_V2 = 'buyerIncentivesV2';

const ifVariant = (variant: string): boolean =>
    getAbTestV2(BUYER_INCENTIVES_V2)?.variant === variant;

export const useBuyerIncentivesV2ClientVariantA = (): boolean | null => {
    const [isVariant, setIsVariant] = useState<boolean | null>(null);

    useEffect(() => {
        setIsVariant(ifVariant('variant-a'));
    }, []);

    return isVariant;
};

export const useBuyerIncentivesV2ClientVariantB = (): boolean | null => {
    const [isVariant, setIsVariant] = useState<boolean | null>(null);

    useEffect(() => {
        setIsVariant(ifVariant('variant-b'));
    }, []);

    return isVariant;
};

export const useBuyerIncentivesV2ClientVariant = (): boolean | null => {
    const isVariantA = useBuyerIncentivesV2ClientVariantA();
    const isVariantB = useBuyerIncentivesV2ClientVariantB();

    return isVariantA || isVariantB;
};

export const useTrackBuyerIncentivesV2 = (): void => {
    useEffect(() => {
        trackAbTestV2Variant(BUYER_INCENTIVES_V2);
    }, []);
};
